<div class="logged-users-header">
  <p class="alc-lighter-text" translate="metric-reports/admin-user/currently-logged-description"></p>
  <span>
    <span class="alc-lighter-text" translate="metric-reports/last-update"></span>
    <span class="alc-lighter-text"> {{ now | dateTimezone: 'short' }}</span>
    <button mat-icon-button (click)="refreshUsersList()">
      <mat-icon color="primary">refresh</mat-icon>
    </button>
  </span>
</div>
<div [hidden]="isLoading">
  <form [formGroup]="form" class="logged-users-form">
    <app-select
      [control]="form.controls.teamIds"
      [items]="routingTagItems"
      [label]="routingTagLabel"
      [multiple]="true"
      [localStorageKey]="routingTagsLocalStorageKey">
    </app-select>
    <app-select
      [control]="form.controls.roleIds"
      [items]="rolesItems"
      [label]="rolesLabel"
      [multiple]="true"
      [localStorageKey]="rolesLocalStorageKey">
    </app-select>
  </form>

  <div class="total-filter-container">
    <p
      class="text-total-number"
      translate="metric-reports/admin-user/total-currently-logged"
      [translateParams]="{ totalLogged: formattedLoggedUsers.length }"></p>
    <mat-divider [vertical]="true" class="divider"></mat-divider>
    <mat-form-field class="filter" appearance="standard">
      <mat-label><span translate="metric-reports/admin-user/currently-logged-filter"></span></mat-label>
      <input matInput (input)="filterByName(filter.value)" #filter />
    </mat-form-field>
  </div>

  <table mat-table [dataSource]="dataSource" matSort>
    <!-- ID Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="metric-reports/admin-user/id"></span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>
    <!-- NAME Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="width-override-name-and-teams">
        <span translate="metric-reports/admin-user/name"></span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>
    <!-- TEAMS Column -->
    <ng-container matColumnDef="teams">
      <th mat-header-cell *matHeaderCellDef class="width-override-name-and-teams">
        <span translate="metric-reports/admin-user/team"></span>
      </th>
      <td mat-cell *matCellDef="let row">
        <div *ngFor="let teamLabel of row.teamLabels | slice: 0:maxNumberTeamsToShow">
          <span>{{ teamLabel }}</span>
        </div>
        <span
          *ngIf="row.teamLabels.length > maxNumberTeamsToShow"
          class="alc-lighter-text"
          [matTooltip]="teamLabelsTooltip">
          {{ row.showMoreTeams }}
        </span>
      </td>
    </ng-container>
    <!-- ASSIGNED MESSAGES Column -->
    <ng-container matColumnDef="assigned" class="width-override-stats">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="metric-reports/admin-user/messages-assigned"></span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        (click)="showTaskDetails(row.assigned)"
        [ngClass]="{ 'has-details': row.assigned.length > 0 }">
        {{ row.assigned.length }}
      </td>
    </ng-container>
    <!-- ANSWERED MESSAGES Column -->
    <ng-container matColumnDef="answered" class="width-override-stats">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="metric-reports/admin-user/messages-answered"></span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        (click)="showTaskDetails(row.answered)"
        [ngClass]="{ 'has-details': row.answered.length > 0 }">
        {{ row.answered.length }}
      </td>
    </ng-container>
    <!-- ARCHIVED MESSAGES Column -->
    <ng-container matColumnDef="archived" class="width-override-stats">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span translate="metric-reports/admin-user/messages-archived"></span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        (click)="showTaskDetails(row.archived)"
        [ngClass]="{ 'has-details': row.archived.length > 0 }">
        {{ row.archived.length }}
      </td>
    </ng-container>
    <!-- LAST CONNECTION Column -->
    <ng-container matColumnDef="lastConnection">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="width-override-delays">
        <span translate="metric-reports/admin-user/last-connection"></span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.lastConnection }}</td>
    </ng-container>
    <!-- LAST ACTION DELAY Column -->
    <ng-container matColumnDef="lastActionDelay">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="width-override-delays">
        <span translate="metric-reports/admin-user/last-action-delay"></span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.formattedLastActionDelay }}</td>
    </ng-container>
    <!-- CUMULATIVE CONNECTION TIME Column -->
    <ng-container matColumnDef="cumulativeConnectionTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="width-override-delays">
        <span translate="metric-reports/admin-user/cumulative-connection-time"></span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.formattedCumulativeConnectionTime }}</td>
    </ng-container>
    <!-- CUMULATIVE PROCESSING TIME Column -->
    <ng-container matColumnDef="cumulativeProcessingTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="width-override-delays">
        <span translate="metric-reports/admin-user/cumulative-processing-time"></span>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.formattedCumulativeProcessingTime }}</td>
    </ng-container>
    <!-- BUTTON LOG OUT Column -->
    <ng-container matColumnDef="buttonLogOut">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button
          *ngIf="row.canBeDisconnected"
          mat-button
          mat-raised-button
          color="primary"
          (click)="disconnectUser(row.id)"
          translate="metric-reports/admin-user/currently-logged-disconnect"></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<div *ngIf="isLoading" class="alc-spinner-wrapper-in-flow alc-progress-container">
  <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
</div>
